import { TaskStatus, type GetProjectsTasksSummaryQuery } from '@gql/graphql';

export interface ProjectTaskSummary {
    completedCount: number;
    totalCount: number;
}

export type ProjectTaskSummaryTask = NonNullable<
    NonNullable<GetProjectsTasksSummaryQuery['tasks']>['edges'][number]
>['node'];

export type ProjectTaskSummaryByProjectId = Record<string, ProjectTaskSummary>;

export const EMPTY_PROJECT_TASK_SUMMARY: ProjectTaskSummary = {
    completedCount: 0,
    totalCount: 0,
};

function createEmptyProjectTaskSummary(): ProjectTaskSummary {
    return { ...EMPTY_PROJECT_TASK_SUMMARY };
}

export function buildProjectTaskSummaryMap(
    projectIds: string[],
    tasks: ProjectTaskSummaryTask[],
): ProjectTaskSummaryByProjectId {
    const summaryMap = Object.fromEntries(
        projectIds.map((projectId) => [
            projectId,
            createEmptyProjectTaskSummary(),
        ]),
    ) as ProjectTaskSummaryByProjectId;

    tasks.forEach((task) => {
        const summary = summaryMap[task.project.id];

        summary.totalCount += 1;

        if (task.status === TaskStatus.Completed) {
            summary.completedCount += 1;
        }
    });

    return summaryMap;
}
